<template>
  <div v-if="!isLoading && contentblocks != undefined">
    <div class="contentblocksPageContainer">
      <ContentBlockContainer
        :page="page"
        :breadCrumb="breadCrumb"
        :contentblocks="contentblocks"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  const props = defineProps<{
    isError?: boolean
  }>()

  const nuxtApp = useNuxtApp()

  const { isLoading, page, contentblocks, breadCrumb } = await useElocusPage(nuxtApp, props.isError)
</script>

